// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span.goal-status-icon{display:flex;justify-content:center;align-items:center}", "",{"version":3,"sources":["webpack://./view/component/goal-status-icon.vue"],"names":[],"mappings":"AACA,sBACI,YAAA,CACA,sBAAA,CACA,kBAAA","sourcesContent":["\nspan.goal-status-icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
